const sortPrice = (first, second) => {
    if (first.value !== second.value) {
        return parseFloat(first.value) - parseFloat(second.value);
    }
    return second.name > first.name ? -1 : 1;
};

const defaultSort = (first, second) => {
    const result = parseInt(first.orderNo, 10) - parseInt(second.orderNo, 10);
    if (isNaN(result)) {
        return first.orderNo < second.orderNo ? -1 : 1;
    }
    return result;
};

export default class OddsTabSort {
    constructor(horsesRowStore, getOrderingValue) {
        this.horsesRowStore = horsesRowStore;
        this.getOrderingValue = getOrderingValue;
        this.sortByBookiePrices = this.sortByBookiePrices.bind(this);
        this.sortByTopPrices = this.sortByTopPrices.bind(this);
        this.getValueFromOdds = this.getValueFromOdds.bind(this);
        this.getValueFromPriceByBookie = this.getValueFromPriceByBookie.bind(this);
    }

    hasPrices(valueFn) {
        return this.horsesRowStore.getHorses().map(valueFn).some(({ value }) => value < 9997);
    }

    sortByTopPrices() {
        const valueFn = this.getValueFromOdds;
        this.sort(valueFn, this.hasPrices(valueFn) ? sortPrice : defaultSort);
    }

    sortByBookiePrices(selectedBookie) {
        const valueFn = this.getValueFromPriceByBookie(selectedBookie);
        this.sort(valueFn, this.hasPrices(valueFn) ? sortPrice : defaultSort);
    }

    /**
     * @private
     */
    getValueFromOdds({ horseName, horseRowElement, bestOdds, orderNo }) {
        return {
            element: horseRowElement,
            value: this.getOrderingValue(bestOdds),
            name: horseName,
            orderNo,
        };
    }

    /**
     * @private
     */
    getValueFromPriceByBookie(selectedBookie) {
        return ({ horseName, horseRowElement, prices, orderNo }) => {
            const price = prices.find(({ bookmaker }) => bookmaker === selectedBookie);
            return {
                element: horseRowElement,
                value: this.getOrderingValue(price),
                name: horseName,
                orderNo,
            };
        };
    }

    /**
     * @private
     */
    sort(valueFunc, sortFunc) {
        this.horsesRowStore
            .getHorses()
            .map(valueFunc)
            .sort(sortFunc)
            .forEach(({ element: { style }, orderNo }, index) => {
                let offset;
                if (orderNo.indexOf('EX') > -1) {
                    offset = 1000;
                } else if (orderNo.indexOf('NR') > -1) {
                    offset = 1500;
                } else {
                    offset = 1;
                }

                const order = index + offset;
                // eslint-disable-next-line no-param-reassign
                style.order = order;
                // eslint-disable-next-line no-param-reassign
                style['-ms-flex-order'] = order;
                // eslint-disable-next-line no-param-reassign
                style['-webkit-order'] = order;
            });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/oddsTabHandler/OddsTabSort.js